import { ReportStatus } from '../types/reports';
import { DisplayStatus } from '../types/status';
import dayjs from 'dayjs';

/**
 * Maps a report's status to a display status, taking into account due dates for past due status
 * @param status The current status of the report
 * @param dueDate Optional due date to check for past due status
 * @returns The display status to show in the UI
 */
export const mapReportStatus = (status: ReportStatus, dueDate?: string): DisplayStatus => {
  if (dueDate && dayjs(dueDate).isBefore(dayjs(), 'day') && status === 'not_submitted') {
    return 'past_due';
  }
  switch (status) {
    case 'pending_review':
      return 'pending';
    case 'rejected':
      return 'needs_attention';
    default:
      return status;
  }
}; 